import React from 'react';

export interface KnowMeTypography {
  bodyText: React.CSSProperties;
  capitalLettersBold: React.CSSProperties;
  capitalLettersRegular: React.CSSProperties;
  f12Medium: React.CSSProperties;
  f12Regular: React.CSSProperties;
  f14Medium: React.CSSProperties;
  f14Regular: React.CSSProperties;
  f16Medium: React.CSSProperties;
  f16Regular: React.CSSProperties;
  f18Medium: React.CSSProperties;
  f18Regular: React.CSSProperties;
  f20Medium: React.CSSProperties;
  f20Regular: React.CSSProperties;
  f24Medium: React.CSSProperties;
  f32Medium: React.CSSProperties;
  fontFamily: string;
  headerMedium: React.CSSProperties;
  headerRegular: React.CSSProperties;
  subHeaderLarge: React.CSSProperties;
  subHeaderMedium: React.CSSProperties;
  weightBold: number;
  weightMedium: number;
  weightRegular: number;
}

export interface KnowMeTypographyOverrides {
  bodyText: true;
  capitalLettersBold: true;
  capitalLettersRegular: true;
  f12Medium: true;
  f12Regular: true;
  f14Medium: true;
  f14Regular: true;
  f16Medium: true;
  f16Regular: true;
  f18Medium: true;
  f18Regular: true;
  f20Medium: true;
  f20Regular: true;
  f24Medium: true;
  f32Medium: true;
  fontFamily: true;
  headerMedium: true;
  headerRegular: true;
  subHeaderLarge: true;
  subHeaderMedium: true;
  weightBold: true;
  weightMedium: true;
  weightRegular: true;
}

export const typography: KnowMeTypography = {
  bodyText: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.2px',
    lineHeight: 1.83,
  },
  capitalLettersBold: {
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '1px',
    lineHeight: 1.6,
    textTransform: 'uppercase' as const,
  },
  capitalLettersRegular: {
    fontSize: '10px',
    fontWeight: 300,
    letterSpacing: '1px',
    lineHeight: 1.4,
    textTransform: 'uppercase' as const,
  },
  f12Medium: {
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '16px',
    textAlign: 'left',
  },
  f12Regular: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '16px',
    textAlign: 'left',
  },
  f14Medium: {
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '22px',
    textAlign: 'left',
  },
  f14Regular: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '22px',
    textAlign: 'left',
  },
  f16Medium: {
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '24px',
    textAlign: 'left',
  },
  f16Regular: {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '24px',
    textAlign: 'left',
  },
  f18Medium: {
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '27px',
    textAlign: 'left',
  },
  f18Regular: {
    fontSize: '18px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '27px',
    textAlign: 'left',
  },
  f20Medium: {
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '30px',
    textAlign: 'left',
  },
  f20Regular: {
    fontSize: '20px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '30px',
    textAlign: 'left',
  },
  // new typography
  f24Medium: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '32px',
    textAlign: 'left',
  },
  f32Medium: {
    fontSize: '32px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '40px',
    textAlign: 'left',
  },
  // new typography end
  fontFamily: ['Roboto'].join(','),
  // Headers
  headerMedium: {
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: 1.5,
  },
  headerRegular: {
    fontSize: '20px',
    fontWeight: 300,
    letterSpacing: '0.2px',
    lineHeight: 1.5,
  },
  subHeaderLarge: {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0.2px',
    lineHeight: 1.88,
  },
  subHeaderMedium: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: 1.71,
  },

  // Font Weight
  weightBold: 600,
  weightMedium: 500,
  weightRegular: 300,
} as const;
